import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { resetPasswordApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Senha deve ter ao menos 6 caracteres"); return; }
    if (password !== confirm) { toast.error("Senhas não coincidem"); return; }
    setLoading(true);
    try {
      await resetPasswordApi(token, password);
      toast.success("Senha redefinida! Faça login com a nova senha.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Token inválido ou expirado");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-md p-8 animate-fade-up">
        <h2 className="font-heading text-2xl font-semibold text-[#0F172A] mb-2">Nova senha</h2>
        <p className="text-sm text-[#475569] mb-6">Defina uma nova senha para acessar sua conta.</p>

        {!token ? (
          <div className="p-4 bg-red-50 border border-red-200 rounded-md text-sm text-red-800">
            Token ausente. <Link className="underline" to="/forgot-password">Solicite novo link</Link>.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label>Nova senha</Label>
              <Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
            </div>
            <div>
              <Label>Confirmar nova senha</Label>
              <Input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
            </div>
            <Button type="submit" data-testid="reset-btn" disabled={loading} className="w-full h-11 bg-[#001E50] hover:bg-[#001740] text-white">
              {loading ? "Salvando..." : "Redefinir senha"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
